module.exports = __webpack_public_path__ + "static/11-dbf1a5b68780ae3c81a54f3261349587.jpg";